import React, { FC } from 'react';

import {
  IconMaterial,
  ValidIconMaterialName,
} from '@abyss/web/ui/IconMaterial';
import { ResultsProps } from '../types';

interface Props extends ResultsProps {
  icon: ValidIconMaterialName;
}

export const ResultsPending: FC<Props> = ({ id, icon }) => {
  const testId = `${id}ResultsPending`;
  return (
    <div className="resultsPending" data-testid={testId} data-cy={testId}>
      <div className="iconLabel">
        <div className="iconLabelIcon">
          <IconMaterial
            icon={icon}
            variant="outlined"
            size={100}
            color="#ccc"
          />
        </div>
        <div className="iconLabelLabel">Search for results</div>
      </div>
    </div>
  );
};
